import React, { useState } from "react";
import { useToast } from "../context/ToastContext";
import { ACService } from "../services/ACService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "./Button.jsx";
import "../assets/styles/footer.css";

import FormInputButton from "./FormInputButton.jsx";
import FooterDisclaimer from "./FooterDisclaimer.jsx";
import useIsMobile from "../hooks/useIsMobile";

import chatIcon from "../assets/images/svg/chatIcon.svg";
import mailIcon from "../assets/images/svg/mailIcon.svg";
import whatsappIcon from "../assets/images/svg/whatsappIcon.svg";
import instagramIcon from "../assets/images/svg/instagram.svg";
import facebookIcon from "../assets/images/svg/facebook.svg";
import youtubeIcon from "../assets/images/svg/youtube.svg";
import safeBrowsingIcon from "../assets/images/svg/safeBrowsing.svg";
import sslIcon from "../assets/images/svg/ssl.svg";
import tiktokIcon from "../assets/images/svg/tiktokIcon.svg";

import visaIcon from "../assets/images/svg/visaIcon.svg";
import masterIcon from "../assets/images/svg/masterIcon.svg";
import dinersIcon from "../assets/images/svg/dinersIcon.svg";
import pixIcon from "../assets/images/svg/pixIconBox.svg";

import logoPurissimaBrown from "../assets/images/svg/logoPurissimaBrown.svg";

const paginasComFooterSimplificado = [
  "/solucoes-purissima",
  "/conheca-formula",
  "/frequencia",
  "/nutraceuticos-opcionais",
  "/sabores",
  "/cart",
  "/checkout",
  "/login",
  "/recuperar",
  "/cadastro",
  "/cadastro-full",
  "/minha-conta",
  "/vsl",
  "/anamnese-v2/solucoes",
];

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const isBasico = window.location.pathname.includes("/basico");
  const [emailNewsletter, setEmailNewsletter] = useState("");
  const { toast } = useToast();

  const isSimplified =
    paginasComFooterSimplificado.some((path) =>
      location.pathname.startsWith(path),
    ) && !location.pathname.startsWith("/checkout/fechamento");

  const formNewsSubscribe = async () => {
    try {
      await ACService.saveLead(null, emailNewsletter, null);
      toast.success("Inscrição realizada com sucesso!");
    } catch {
      toast.error("Erro ao inscrever-se na newsletter.");
    }
  };

  const handleClick = () => {
    document.getElementById("bot_icon")?.click();
  };

  if (isSimplified) {
    return (
      <footer className="footerCheckout py-4 py-lg-5">
        <div className="container" style={{ maxWidth: "1120px" }}>
          <div className="row align-items-center justify-content-center">
            <div className="col-auto">
              <img src={logoPurissimaBrown} alt="logoPurissimaBrown" />
            </div>
          </div>
        </div>
        <FooterDisclaimer />
      </footer>
    );
  }

  const newsletterContent = (
    <>
      <h2>
        <strong>Inscreva-se na nossa newsletter</strong>
      </h2>
      <FormInputButton
        label="Insira seu melhor e-mail"
        float
        value={emailNewsletter}
        onChange={(e) => setEmailNewsletter(e.target.value)}
        onClick={() => {
          formNewsSubscribe();
        }}
        buttonLabel="Cadastrar"
        disabled={false}
        type="text"
      />
    </>
  );

  return (
    <footer className="footer py-4 py-lg-5">
      <div
        className="container text-center text-lg-start"
        style={{ maxWidth: "1120px" }}
      >
        <div className="row justify-content-center gap-lg-4">
          <div className="col-11 col-lg-12">
            <div className="row justify-content-center">
              <div className="col-12 order-1 mb-lg-4">
                <img
                  src={logoPurissimaBrown}
                  alt="logoPurissimaBrown"
                  width="210"
                  height={39}
                  className="logoPurissimaFooter"
                />
              </div>

              <div className="col-6 col-lg-auto order-4 order-lg-2 my-4 my-lg-0">
                <ul className="institutionalMenu text-start">
                  <li>
                    <Link
                      to={`${process.env.PUBLIC_URL}/minha-conta/meus-pedidos`}
                    >
                      <strong>Sua conta</strong>
                    </Link>
                  </li>
                  {/* <li>
                  <Link to={`${process.env.PUBLIC_URL}/prescritores`}>
                    <strong>Torne-se um prescritor</strong>
                  </Link>
              </li> */}
                  <li>
                    <Link to={`${process.env.PUBLIC_URL}/biblioteca`}>
                      <strong>Biblioteca</strong>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.PUBLIC_URL}/politica-de-privacidade`}
                    >
                      <strong>Política de privacidade</strong>
                    </Link>
                  </li>
                  <li>
                    <Link to={`${process.env.PUBLIC_URL}/termos-e-condicoes`}>
                      <strong>Termos e condições</strong>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.PUBLIC_URL}/politica-de-cancelamento`}
                    >
                      <strong>
                        <span className="d-lg-block">
                          Cancelamentos, trocas{" "}
                        </span>
                        <span className="d-lg-block">e reembolsos</span>
                      </strong>
                    </Link>
                  </li>
                </ul>
              </div>

              {isMobile ? (
                <div className="col-12 col-lg order-3">{newsletterContent}</div>
              ) : null}

              <div className="col-6 col-lg pe-lg-4 order-5 order-lg-4 my-4 my-lg-0">
                {!isMobile ? (
                  <div className="row justify-content-center justify-content-lg-between">
                    <div className="col-11 col-lg">{newsletterContent}</div>
                    <div className="col-auto py-4 py-lg-0">
                      <h2>
                        <strong>Siga-nos</strong>
                      </h2>
                      <div className="footerIcons socialIcons d-flex gap-2">
                        <div>
                          <a
                            href="https://www.instagram.com/purissima.saude/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={instagramIcon}
                              alt="instagramIcon"
                              width={33}
                              height={33}
                            />
                          </a>
                        </div>
                        <div>
                          <a
                            href="https://www.facebook.com/profile.php?id=61579935944905"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={facebookIcon}
                              alt="facebookIcon"
                              width={33}
                              height={33}
                            />
                          </a>
                        </div>
                        <div>
                          <a
                            href="https://www.youtube.com/@FlavioBPassos"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={youtubeIcon}
                              alt="youtubeIcon"
                              width={33}
                              height={33}
                            />
                          </a>
                        </div>
                        <div>
                          <a
                            href="https://www.tiktok.com/@purissima.saude?_t=ZM-90KLnwGcmCJ&_r=1 "
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={tiktokIcon}
                              alt="tiktokIcon"
                              width={33}
                              height={33}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <hr className="d-none d-lg-block" />
                <div className="row justify-content-lg-between">
                  <div className="col-12 col-lg-auto">
                    <h2 className="mb-1 mb-lg-3">
                      <strong>Comprar aqui é seguro</strong>
                    </h2>
                    <div className="footerIcons securityIcons row justify-content-center g-2">
                      <div className="col-auto">
                        <img src={sslIcon} alt="sslIcon" />
                      </div>
                      <div className="col-auto">
                        <img src={safeBrowsingIcon} alt="safeBrowsingIcon" />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-auto mt-3 mt-lg-0">
                    <h2 className="mb-1 mb-lg-3">
                      <strong>Formas de Pagamento</strong>
                    </h2>
                    <div className="footerIcons paymentIcons row justify-content-center g-2">
                      <div className="col-auto">
                        <img src={visaIcon} alt="visaIcon" />
                      </div>
                      <div className="col-auto">
                        <img src={masterIcon} alt="masterIcon" />
                      </div>
                      <div className="col-auto">
                        <img src={dinersIcon} alt="dinersIcon" />
                      </div>
                      <div className="col-auto">
                        <img src={pixIcon} alt="pixIcon" />
                      </div>
                    </div>
                  </div>
                  {isMobile && (
                    <div className="col-12 mt-3 mt-lg-0">
                      <h2 className="mb-1 mb-lg-3">
                        <strong>Siga-nos</strong>
                      </h2>
                      <div className="footerIcons socialIcons row justify-content-center g-2">
                        <div className="col-auto">
                          <a
                            href="https://www.instagram.com/purissima.saude/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={instagramIcon} alt="instagramIcon" />
                          </a>
                        </div>
                        <div className="col-auto">
                          <a
                            href="https://www.facebook.com/profile.php?id=61579935944905"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={facebookIcon} alt="facebookIcon" />
                          </a>
                        </div>
                        <div className="col-auto">
                          <a
                            href="https://www.youtube.com/@FlavioBPassos"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={youtubeIcon} alt="youtubeIcon" />
                          </a>
                        </div>
                        <div className="col-auto">
                          <a
                            href="https://www.tiktok.com/@purissima.saude?_t=ZM-90KLnwGcmCJ&_r=1 "
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={tiktokIcon} alt="tiktokIcon" />
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-12 col-lg-auto order-2 order-lg-5 my-4 my-lg-0">
                <div className="d-flex h-100 flex-column justify-content-lg-between footerContactSection">
                  <div>
                    <h2>
                      <strong>Dúvidas</strong>
                    </h2>
                    <ul className="institutionalMenu  institutionalMenuContact">
                      <li>
                        <Link
                          onClick={handleClick}
                          aria-label="Abrir chat"
                          className="d-inline-flex align-items-center gap-2"
                        ><img
                              src={chatIcon}
                              alt="chatIcon"
                              width={18}
                              height={20.8}
                            />
                          <strong>
                            
                            Chat do site
                          </strong>
                        </Link>
                      </li>
                      <li>
                        <a
                          href="mailto:contato@purissima.com"
                          aria-label="Abrir email"
                          className="d-inline-flex align-items-center gap-2"
                        ><img
                              src={mailIcon}
                              alt="mailIcon"
                              width={18}
                              height={20.8}
                            />
                          <strong>
                            
                            contato@purissima.com
                          </strong>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://wa.me/551152836305"
                          aria-label="Abrir WhatsApp"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-inline-flex align-items-center gap-2"
                        >
                          <img
                              src={whatsappIcon}
                              alt="whatsappIcon"
                              width={18}
                              height={20.8}
                            />
                          <strong>
                            
                            (11) 5283-6305
                          </strong>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="horarioAtendimento pt-4 py-lg-0">
                    <h2 className="mb-2">
                      <strong>Horário de atendimento</strong>
                    </h2>
                    <p className="m-0">Segunda a sexta 9h-19h</p>
                    <p className="m-0">Sábado e domingo 9h-11h</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterDisclaimer />
    </footer>
  );
};

export default Footer;
